import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/'
import NProgress from 'nprogress'
import staticRoute from './staticRoute'
import common from '../service/common'
import  {applyRouter,diagRouter,checkRouter,localDiagRouter,adminRouter,commonRouter,remoteAdminRouter} from '@/router/routerTable';
Vue.use(VueRouter)
NProgress.configure({ showSpinner: false });

const router = new VueRouter({
    mode: 'history',
    routes: staticRoute
})

const Layout = () => import(/* webpackChunkName: 'index' */ '../page/layout')
router.beforeEach((to,form,next)=>{
    console.log(to);
    //判断用户是否登录
    // 开启进度条
    NProgress.start();
    if(common.getStorage('userInfo')){
        if(store.state.addRouter==0){
            //组织路由
            let roles=common.getStorage('roles');
            //大图诊断（远程诊断、审核、本地诊断）
            if(roles.indexOf('remote_diag')>-1||roles.indexOf('remote_check')>-1||roles.indexOf('remote_apply')>-1){
                router.addRoutes([{
                    path: '/bigImageDiag',
                    component: () => import(/* webpackChunkName: 'home' */ '../components/Viewm/ViewmUlti'),
                }])
            }
            //监控大屏（管理员、监控权限）
            if(roles.indexOf('manage_hosp')>-1||roles.indexOf('data_monitoring')>-1){
                router.addRoutes([{
                    path: '/real',
                    component: () => import('../page/admin/real')
                }])
            }
            let newRouter=commonRouter
            if(roles.indexOf('manage_hosp')>-1){
                newRouter=newRouter.concat(adminRouter);
            }
            if(roles.indexOf('remote_apply')>-1){
                newRouter=newRouter.concat(applyRouter);
            }
            if(roles.indexOf('remote_check')>-1){
                newRouter=newRouter.concat(checkRouter);
            }
            if(roles.indexOf('remote_diag')>-1){
                newRouter=newRouter.concat(diagRouter);
            }
            //本地诊断
            if(roles.indexOf('remote_diag')>-1||roles.indexOf('remote_check')>-1||roles.indexOf('remote_apply')>-1){
                newRouter=newRouter.concat(localDiagRouter);
            }
            //远程病例全院查看
            if(roles.indexOf('local_look')>-1||(roles.indexOf('manage_hosp')>-1&&(roles.indexOf('remote_check')>-1||roles.indexOf('remote_diag')>-1))){
                newRouter=newRouter.concat(remoteAdminRouter);
            }
            let endRouter=[
                {
                    path: '/home',
                    component: Layout,
                    children: newRouter
                }
            ];
            router.addRoutes(endRouter);
            store.state.addRouter=1;
            next(to.path);
        }
        else{
            next();
        }
    }else{
        next();
    }
})
router.afterEach(()=>{
    NProgress.done(); // 结束Progress
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js